
'use strict';//Indicating browser should run only in java script mode
//http://stackoverflow.com/questions/20369377/how-to-use-http-get-in-angularjs-correctly-in-specific-for-an-external-api-cal

angular.module('EMR.Home').service('EasyFormReminderRuelsCmnService', ['CommonService', function (CommonService) {
    
    ///  *******PURPOSE:THIS IS USED TO AUTO EXECUTE EASY FORM REMINDERS FOR A PATIENT MODULE WISE
    //*******CREATED BY: DURGA PRASAD V
    //*******CREATED DATE:08/03/2016
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
    this.EasyFormsRemaindersRuleAutoExecutionforPatient = function (postData) {

        postData.practicemodel = EMRPracticeModel;

        var timeOut = 60 * 1000 * 4;

        //postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST;

        //    return CommonService.PostData('POST', CommonService.EMRClinicalManagement_HTMLTemplates() + "EasyFormsRemaindersRuleAutoExecutionforPatient", postData).then(
        return CommonService.PostData('POST', CommonService.EHR_EF_ReminderRules_API() + "EasyFormsRemaindersRuleAutoExecutionforPatient", postData, timeOut).then(
            function (result) {
                return result;
            });
    };
    //################### NEW BLOCK END #########################

    ///  *******PURPOSE:THIS IS USED TO AUTO EXECUTE HM REMINDERS FOR A PATIENT MODULE WISE
    //*******CREATED BY: RAVI TEJA.P
    //*******CREATED DATE:6/14/2016
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
    this.EasyFormsHMRemaindersRuleAutoExecutionforPatient = function (postData) {

        postData.practicemodel = EMRPracticeModel;
        postData.PracticeName = EMRPracticeModel.PracticeName;
        postData.LoggedUserName = EMRPracticeModel.LoggedUserName;
        postData.QuestBusinessUnitsUsingForLoggedPractice = EMRPracticeModel.practicesettingsmodel.QuestBusinessUnitsUsingForLoggedPractice;

        var timeOut = 60 * 1000;
        //postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST;

        //     return CommonService.PostData('POST', CommonService.EMRClinicalManagement_HTMLTemplates() + "EasyFormsHMRemaindersRuleAutoExecutionforPatient", postData).then(

        return CommonService.PostData('POST', CommonService.EHR_EF_ReminderRules_API() + "EasyFormsHMRemaindersRuleAutoExecutionforPatient", postData, timeOut).then(
            function (result) {
                return result;
            });



    };
    //################### NEW BLOCK END #########################

}]);
